/**
 * Created by piotr.pozniak@thebeaverhead.com on 21/10/2024
 */

import React from "react";
import WebsiteMissingWarning from "../../WebsiteMissingWarning";
import WebsitesVerifiedInfo from "../../WebsiteVerifiedInfo";
import InstallAccordion from "../../InstallAccordion";
import ClipboardCopyInput from "../../../../component/ClipboardCopyInput";
import { nucleusAlertsInstallJavascript } from "../../../../templates/WidgetPageTemplate/InstallTab/helpers";
import appConfig from "../../../../../../appConfig";
import OneTimerAlert from "./OneTimerAlert";

const NucleusInstructions = ({
  uuid,
  slug,
  widgetType,
  widgetTypePrintable,
  onGoToAddWebsite,
}) => {
  return (
    <div>
      {/*<FeatureFlag name={"nucleus-embeddable"}>
        <div className={"w-100 d-flex align-items-center flex-column"}>
          <p className={"text-center"}>
            Watch our tutorial video below or{" "}
            <a
              target={"_blankNucleusInstructions"}
              href={
                "https://help.display.church/en/articles/6778262-nucleus-embedding-your-view"
              }
            >
              Read our Article
            </a>
            .
          </p>
          <div className={"install-modal--video-tutorial"}>
            <div>
              <iframe
                src="https://player.vimeo.com/video/773596825?badge=0&amp;autopause=0&amp;player_id=0&amp;app_id=58479"
                frameBorder="0"
                allow="autoplay; fullscreen; picture-in-picture; clipboard-write"
                title="Embedding into Nucleus"
              ></iframe>
            </div>
            <script src="https://player.vimeo.com/api/player.js"></script>
          </div>
        </div>
      </FeatureFlag>*/}

      <div className={"my-4"}>
        <WebsiteMissingWarning onAddWebsite={onGoToAddWebsite} />
        <WebsitesVerifiedInfo />
      </div>
      <InstallAccordion
        title={`Installing ${appConfig.displayName} on Nucleus`}
        defaultExpanded={true}
        expandable={false}
      >
        <OneTimerAlert />
        <ol>
          <li>
            In your Nucleus dashboard, click on <strong>Settings</strong>.
          </li>
          <li>
            Within the Settings menu, click on <strong>Code Injection</strong>.
          </li>
          <li>
            Copy and paste the following JavaScript into the{" "}
            <span className={"text-purple"}>
              Custom CSS & Javascript (Advanced)
            </span>{" "}
            section.
            <ClipboardCopyInput
              id={"embeddable_script"}
              value={nucleusAlertsInstallJavascript}
              placeholder={`${widgetTypePrintable} embeddable javascript`}
            />
          </li>
        </ol>
      </InstallAccordion>
    </div>
  );
};

export default NucleusInstructions;
